import React from "react";
import {motion} from "framer-motion";
import {Line, Pie} from "react-chartjs-2";
import {
	Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col,
} from "reactstrap";
import {
	dashboard24HoursPerformanceChart, dashboardEmailStatisticsChart, dashboardNASDAQChart,
} from "variables/charts.js";
import RefStrap from "lib/Utils/RefStrap";

const MotionCard = motion(RefStrap(Card));
const cardControl = {
	animate: {
		transition: {
			delayChildren: 0.05, staggerChildren: 0.1, staggerDirection: 1
		}
	}
}
const fadeIn = {
	initial: {opacity: 0, scale: 0.6}, animate: {opacity: 1, scale: 1,transition: {duration: 0.2, ease: "easeOut"}},
};

function Dashboard()
{
	return (<>
		<motion.div initial="initial" animate="animate" exit="exit" variants={cardControl} className="content container-fluid py-4">
			<Row className="g-3">
				<Col lg="3" md="6" sm="6">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								<Col md="4" xs="5">
									<div className="icon-big text-center icon-warning">
										<i className="nc-icon nc-globe text-warning"/>
									</div>
								</Col>
								<Col md="8" xs="7">
									<div className="numbers">
										<p className="card-category">Cards In Stock</p>
										<CardTitle tag="p">2.5M</CardTitle>
										<p/>
									</div>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<hr/>
							<div className="stats">
								<i className="fas fa-sync-alt"/> Total
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
				<Col lg="3" md="6" sm="6">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								<Col md="4" xs="5">
									<div className="icon-big text-center icon-warning">
										<i className="nc-icon nc-money-coins text-success"/>
									</div>
								</Col>
								<Col md="8" xs="7">
									<div className="numbers">
										<p className="card-category">Revenue</p>
										<CardTitle tag="p">$1,345</CardTitle>
										<p/>
									</div>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<hr/>
							<div className="stats">
								<i className="far fa-calendar"/> 24 hrs ago
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
				<Col lg="3" md="6" sm="6">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								<Col md="4" xs="5">
									<div className="icon-big text-center icon-warning">
										<i className="nc-icon nc-vector text-danger"/>
									</div>
								</Col>
								<Col md="8" xs="7">
									<div className="numbers">
										<p className="card-category">Trade-ins</p>
										<CardTitle tag="p">23</CardTitle>
										<p/>
									</div>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<hr/>
							<div className="stats">
								<i className="far fa-clock"/> In the last hour
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
				<Col lg="3" md="6" sm="6">
					<MotionCard variants={fadeIn} className="card-stats">
						<CardBody>
							<Row>
								<Col md="4" xs="5">
									<div className="icon-big text-center icon-warning">
										<i className="nc-icon nc-delivery-fast text-primary"/>
									</div>
								</Col>
								<Col md="8" xs="7">
									<div className="numbers">
										<p className="card-category">Most sold brand</p>
										<CardTitle tag="p">Apple</CardTitle>
										<p/>
									</div>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<hr/>
							<div className="stats">
								<i className="fas fa-sync-alt"/> Last 2 weeks
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
			<Row>
				<Col md="12">
					<MotionCard variants={fadeIn}>
						<CardHeader>
							<CardTitle tag="h5">Users Behaviour</CardTitle>
							<p className="card-category">24 Hours performance</p>
						</CardHeader>
						<CardBody>
							<Line
								data={dashboard24HoursPerformanceChart.data}
								options={dashboard24HoursPerformanceChart.options}
								width={400}
								height={100}
							/>
						</CardBody>
						<CardFooter>
							<hr/>
							<div className="stats">
								<i className="fa fa-history"/> Updated 3 minutes ago
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
			<Row>
				<Col md="4">
					<MotionCard variants={fadeIn}>
						<CardHeader>
							<CardTitle tag="h5">Email Statistics</CardTitle>
							<p className="card-category">Last Campaign Performance</p>
						</CardHeader>
						<CardBody style={{height: "266px"}}>
							<Pie
								data={dashboardEmailStatisticsChart.data}
								options={dashboardEmailStatisticsChart.options}
							/>
						</CardBody>
						<CardFooter>
							<div className="legend">
								<i className="fa fa-circle text-primary"/> Opened{" "}
								<i className="fa fa-circle text-warning"/> Read{" "}
								<i className="fa fa-circle text-danger"/> Deleted{" "}
								<i className="fa fa-circle text-gray"/> Unopened
							</div>
							<hr/>
							<div className="stats">
								<i className="fa fa-calendar"/> Number of emails sent
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
				<Col md="8">
					<MotionCard variants={fadeIn} className="card-chart">
						<CardHeader>
							<CardTitle tag="h5">NASDAQ: AAPL</CardTitle>
							<p className="card-category">Line Chart with Points</p>
						</CardHeader>
						<CardBody>
							<Line
								data={dashboardNASDAQChart.data}
								options={dashboardNASDAQChart.options}
								width={400}
								height={100}
							/>
						</CardBody>
						<CardFooter>
							<div className="chart-legend">
								<i className="fa fa-circle text-info"/> Tesla Model S{" "}
								<i className="fa fa-circle text-warning"/> BMW 5 Series
							</div>
							<hr/>
							<div className="card-stats">
								<i className="fa fa-check"/> Data information certified
							</div>
						</CardFooter>
					</MotionCard>
				</Col>
			</Row>
		</motion.div>
	</>);
}

export default Dashboard;
